module.exports = __webpack_public_path__ + "static/Clamato-DFW-Lunch-Truck-a0d57e5c928bcc6645811ec6b031f2f3.jpg";